import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/AdditionalOptions.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/AdminBenefits.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/CommonFooter.js");
;
import(/* webpackMode: "eager", webpackExports: ["FrequentlyAskedQuestionView2"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/FrequentlyAskedQuestionView.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/Layout.js");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/qr-kode/qr-kode.css");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/qr-kode/qr-kode-responsive.css");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/node_modules/next/dist/client/link.js");
